module.exports = "img/voip.286bad4.png";